import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/primeng';
import { LocalStorageService } from 'ng2-webstorage';
import { MessageService } from 'primeng/components/common/messageservice';
@Component({
  selector: 'teachersubjectS',
  templateUrl: 'teachersubjectS.component.html',
  styleUrls: ['teachersubjectS.component.scss']
})

export class AddTeachersubjectSComponent implements OnInit {
  public schoolId: any;
  public department: any;
  // display: boolean = false;
  display = "none"
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public searchString: string;
  public spinnershow: boolean = false;
  public rolesList: any;
  public departmentList: any;
  public info:boolean=false;
  public isList:boolean=true;
  constructor( private messageService: MessageService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService) {
    this.schoolId = this.localStorage.retrieve('schoolid');
    
  }

  ngOnInit() {
    //this.GetRolesList();
    //this.GetDepartment(this.bigCurrentPage);
  }

  
  roleinfo(){
    this.info=true;
   }
 
 
 editSemsub(semsub){
   this.departmentList.filter(ele=>{
     if(ele.Id==semsub.Id){
     
       // this.display = true;
       this.display = "block";
     }
   })
 }
 
 
 addSemsub() {
 
   this.display= "block"
   // this.display = true;
 }
 onCloseHandled() {
   this.display= "none";
 }
 
 
 

}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/teachersubjectschool/teachersubjectS.component.ts